var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1465,
    cy: 12,
    r: 12,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14648 15.0925C8.05234 15.665 9.13224 16 10.2913 16C14.1006 16 16.2485 12.8335 16.122 9.99416C16.5215 9.70983 16.8696 9.3554 17.1465 8.95034C16.7786 9.11003 16.383 9.21908 15.9677 9.26972C16.3909 9.02045 16.7153 8.62317 16.8696 8.1519C16.474 8.38169 16.0349 8.55307 15.5682 8.64265C15.1884 8.24537 14.6584 8 14.065 8C12.7398 8 11.7667 9.21519 12.0674 10.481C10.3664 10.3953 8.85535 9.59299 7.84269 8.37001C7.30471 9.27751 7.56579 10.4654 8.4756 11.0652C8.13936 11.0536 7.82291 10.964 7.54601 10.8121C7.52228 11.7468 8.20661 12.6232 9.19158 12.8179C8.90281 12.8958 8.58636 12.9114 8.26595 12.853C8.52702 13.6553 9.28256 14.2395 10.1805 14.2551C9.32212 14.9211 8.2343 15.2171 7.14648 15.0925Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.153afa36ad0d8b5e66c2402d4533c897.svg";
export { ForwardRef as ReactComponent };